// Generado por scripts/sync-sw-version.js — no editar a mano
export const APP_VERSION = '1.3.0';
